import { render, staticRenderFns } from "./InstallApp.vue?vue&type=template&id=643792a8&scoped=true"
import script from "./InstallApp.vue?vue&type=script&lang=js"
export * from "./InstallApp.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=643792a8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643792a8",
  null
  
)

export default component.exports